import React from 'react';
import { getLogoData } from './logo';
import MediaQuery from '../../common/mediaQuery/MediaQuery';

const BrandLogo = ({ modelInfo }) => {
  const logo = getLogoData(modelInfo);
  return (
    <a
      href={modelInfo.homepageUrl}
      className="global-nav__brand stat-logo"
      data-dtm="global nav">
      <MediaQuery width={logo.logoBreakpoint}>
        {matches => (
          <img
            className="global-nav__logo"
            alt={modelInfo.brand}
            src={matches ? logo.lowDpiHorizontalLogoUrl : logo.lowDpiLogoUrl}
            srcSet={
              matches ? logo.highDpiHorizontalLogoUrl : logo.highDpiLogoUrl
            }
          />
        )}
      </MediaQuery>
    </a>
  );
};

export default BrandLogo;
